import {
  dropOperacao,
  dropStatusDfe,
  dropXmlManifesto,
  dropSituacaoManifesto,
  dropTipoDoctoManifesto,
} from 'utils/drops';

const getManifestaçõesFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: dropSituacaoManifesto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'xml',
    column: 'situacao',
    label: 'XML',
    type: 'select',
    options: dropXmlManifesto,
    multiple: true,
    defaultValue: ['IMPORTAR', 'INDISPONIVEL'],
  },
  {
    name: 'rsocial',
    column: 'emitente',
    label: 'Razão Social',
    defaultValue: '',
  },
  {
    name: 'cnpj',
    column: 'emitente',
    label: 'CNPJ',
    type: 'number',
    defaultValue: '',
  },
  {
    name: 'ie',
    column: 'emitente',
    label: 'Inscrição Estadual',
    defaultValue: '',
  },
  {
    name: 'dhemissao.i',
    column: 'dhemissao',
    label: 'Data/Hora de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dhemissao.f',
    column: 'dhemissao',
    label: 'Data/Hora de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'filial',
    label: 'Filial',
    type: 'select',
    options: drops?.Filial,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'numero',
    column: 'nf',
    label: 'Nº do Documento',
    type: 'number',
    defaultValue: '',
    initial: true,
  },
  {
    name: 'tpdocto',
    column: 'nf',
    label: 'Tipo do Documento',
    type: 'select',
    options: dropTipoDoctoManifesto,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'status',
    column: 'nf',
    label: 'Status',
    type: 'select',
    options: dropStatusDfe,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'operacao',
    column: 'nf',
    label: 'Operação',
    type: 'select',
    options: dropOperacao,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'valor',
    column: 'nf',
    label: 'Valor',
    type: 'currency',
    defaultValue: '',
  },
  {
    name: 'serie',
    column: 'nf',
    label: 'Série',
    type: 'number',
    defaultValue: '',
  },
];

export default getManifestaçõesFilterFields;
